import React from "react";
import { Tag } from "@design-system/Tag/Tag";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { GROUP_PATH_SEPARATOR } from "./buildGroupPathSegments";
import styles from "./GroupSelectField.module.scss";

interface GroupPathLabelProps {
    segments: string[];
}

export const GroupPathLabel: React.FC<GroupPathLabelProps> = ({ segments }) => {
    if (segments.length <= 1) {
        return segments.length === 1 ? segments[0] : null;
    }
    const leafName = segments[segments.length - 1];
    const fullPath = segments.join(GROUP_PATH_SEPARATOR);
    return (
        <>
            <span className={styles.leaf}>{leafName}</span>
            <Tooltip content={fullPath}>
                <span className={styles.nestedIndicator}>
                    <Tag color="primary" size="sm">
                        Nested
                    </Tag>
                </span>
            </Tooltip>
        </>
    );
};
